exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.page-container[data-v-13877386]{position:relative;height:100%;width:100%;overflow:hidden\n}\n@media screen and (max-width: 500px){\n.page-container[data-v-13877386]{width:100%\n}\n}\n", "", {"version":3,"sources":["/data/cloudrec/workspace/hbey/cloudApplicationWeb/src/layout/index.vue"],"names":[],"mappings":";AAgBA,iCACE,kBACA,YACA,WACA,eAAgB;CACjB;AAAA;AAEG,iCACE,UAAU;CACX;CAAA","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.page-container {\n  position:relative;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n@media screen and (max-width: 500px) {\n    .page-container {\n      width:100%;\n    }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-13877386","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layout/index.vue
// module id = v/4j
// module chunks = 20